import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import * as amenityActions from './../../../../actions/amenityAction';
import Amenities from './Amenities';

const mapStateToProps = state => {
    return {
        amenityState: state.amenityReducer,
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        getListAmenities: () => dispatch(amenityActions.getListAmenity()),
        deleteAmenityDetail: (amenity) => dispatch(amenityActions.deleteAmenityDetail(amenity)),
    }
};

export default withTranslation()(connect(mapStateToProps, mapDispatchToProps)(Amenities));
